<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1200px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create Work Session Type
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Work Session Type"
      text="Create Work Session Type"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Name"
                outlined
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="code"
                v-validate="'required'"
                :error-messages="errors.collect('code')"
                data-vv-name="code"
                label="Code"
                outlined
              />
            </v-col>
          </v-row>
          <v-row
            v-for="day in days" 
            :key="day.key"
          >
            <v-col class="py-0">
              <v-text-field
                :label="day.label"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="schedule[day.key].startMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-validate="startRule(day)"
                    :value="formatTime(schedule[day.key].start)"
                    :error-messages="errors.collect(`${day.key}Start`)"
                    :data-vv-name="`${day.key}Start`"
                    :data-vv-as="`${day.label} start time`"
                    outlined
                    label="From"
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-clock
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-model="schedule[day.key].start"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="onTimePicked(day.key, 'start')"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="schedule[day.key].endMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-validate="schedule[day.key].start ? 'required' : ''"
                    :value="formatTime(schedule[day.key].end)"
                    :error-messages="errors.collect(`${day.key}End`)"
                    :data-vv-name="`${day.key}End`"
                    :data-vv-as="`${day.label} end time`"
                    outlined
                    label="To"
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-clock
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-model="schedule[day.key].end"
                  :min="schedule[day.key].start"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="onTimePicked(day.key, 'end')"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="schedule[day.key].lunchFromMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatTime(schedule[day.key].lunchFrom)"
                    outlined
                    label="Lunch Range From"
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-clock
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-model="schedule[day.key].lunchFrom"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="schedule[day.key].lunchFromMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="schedule[day.key].lunchToMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatTime(schedule[day.key].lunchTo)"
                    outlined
                    label="Lunch Range To"
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-clock
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-model="schedule[day.key].lunchTo"
                  :min="schedule[day.key].lunchFrom"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="schedule[day.key].lunchToMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"     
          class="white--text px-10"     
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      const days = [
        { key: 'monday', label: 'Monday' },
        { key: 'tuesday', label: 'Tuesday' },
        { key: 'wednesday', label: 'Wednesday' },
        { key: 'thursday', label: 'Thursday' },
        { key: 'friday', label: 'Friday' },
        { key: 'saturday', label: 'Saturday' },
        { key: 'sunday', label: 'Sunday' },
      ]

      const schedule = {}
      days.forEach(day => {
        schedule[day.key] = {
          start: null,
          end: null,
          lunchFrom: null,
          lunchTo: null,
          startMenu: false,
          endMenu: false,
          lunchFromMenu: false,
          lunchToMenu: false,
        }
      })

      return {
        name: null,
        code: null,
        dialog: false,        
        progressing: false,    
        days,
        schedule,
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },

    methods: {
      prepareFormData () {
        const details = this.days.map((day, index) => {
          const s = this.schedule[day.key]
          return {
            day: index + 1,
            start_time: s.start || '00:00',
            end_time: s.end || '00:00',
            lunch_range_from: s.lunchFrom || '00:00',
            lunch_range_to: s.lunchTo || '00:00',
          }
        })

        return {
          name: this.name,
          code: this.code,
          details,
        }
      },
      onTimePicked (dayKey, field) {
        const val = this.schedule[dayKey][field]

        this.schedule[dayKey][field] = this.$moment(val, 'HH:mm').format('HH:mm')
        const name = `${dayKey}${field.charAt(0).toUpperCase() + field.slice(1)}`
        this.$validator.validate(name)

        this.schedule[dayKey][`${field}Menu`] = false
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true

            this.$api.workSessionTypes().create(this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'Work Sesssion Type created succesfully' })
                this.$emit('created')     
                this.dialog = false
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Unable to create work session', 
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },   
      startRule (day) {
        const end = this.schedule[day.key].end

        if (day.key === 'saturday' || day.key === 'sunday') {
          return end ? 'required' : ''
        }

        return 'required'
      },
      formatTime (time) {
        if (!time) return ''
        return this.$moment(time, 'HH:mm').format('hh:mm A')
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
